import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { UTILITY_USER_ROLE_ADMIN } from 'common/utility/userRoles';

import branch from 'client/core/branch';
import withScreenId from 'client/helpers/withScreenId';
import withTransitionHook from 'client/helpers/withTransitionHook';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';
import { SCREEN_ID_UTILITY_PROFIT_ADMIN_REGISTER_ADDRESS } from 'client/constants/screenIds';

import UtilityPartnerActions from 'client/actions/UtilityPartner';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrUtilityProfitAdminRegisterAddressForm from 'client/components/SrUtilityProfitAdminRegisterAddressForm/SrUtilityProfitAdminRegisterAddressForm';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_PROFIT_ADMIN_REGISTER_ADDRESS)
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN],
  addRedirectQueryParam: true,
})
@branch({
  utilityPartnerList: ['utilityPartners', 'list'],
})
class UtilityProfitAdminRegisterAddressPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Register Address | Utility Profit',
  });

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    utilityPartnerList: PropTypes.array,
  };

  static fetchData(match, inject) {
    return Promise.all([UtilityPartnerActions.getList(inject)]);
  }

  render() {
    const { dispatch, utilityPartnerList } = this.props;

    return (
      <SrBox paddingTop="30px" margin="0 auto" width="400px">
        <SrBox paddingBottom="10px" textAlign="center">
          <SrText
            weight="800"
            display="block"
            size="26"
            lineHeight="33px"
            font="greycliff"
            color="green"
          >
            Register a new
          </SrText>
          <SrText weight="800" display="block" size="26" lineHeight="33px" font="greycliff">
            Utility Partner Address
          </SrText>
        </SrBox>
        <SrUtilityProfitAdminRegisterAddressForm
          dispatch={dispatch}
          utilityPartnerList={utilityPartnerList}
        />
      </SrBox>
    );
  }
}

UtilityProfitAdminRegisterAddressPage.displayName = 'UtilityProfitAdminRegisterAddressPage';

export default UtilityProfitAdminRegisterAddressPage;
